import { miscHelpers } from '@approvalmax/utils';
import { hooks } from '@approvalmax/utils';
import { domain } from 'modules/data';
import { useEffect } from 'react';
import { routingService } from 'services/routing';
import { useSignInWith } from 'shared/hooks/(auth)/useSignInWith/useSignInWith';
import { SignInPostActionType } from 'shared/hooks/(auth)/useSignInWith/useSignInWith.types';
import { getPath, Path } from 'urlBuilder';

export const useSignInWithDisconnectPageData = () => {
    const [realmId] = hooks.useQueryParam('realmId');
    const [initialOAuthProvider] = hooks.useQueryParam('oauthProvider');
    const oAuthProvider = initialOAuthProvider ? initialOAuthProvider.toLowerCase() : null;

    const { onSignInWith } = useSignInWith({
        startingPoint: domain.SsoStartingPoint.Marketplace,
        postAction: {
            type: SignInPostActionType.Disconnect,
            externalOrgId: realmId,
        },
    });

    useEffect(() => {
        if (miscHelpers.isEnumValue(domain.OAuthProvider, oAuthProvider)) {
            onSignInWith(oAuthProvider);
        } else {
            routingService.replace(getPath(Path.login));
        }
    }, [oAuthProvider, realmId, onSignInWith]);
};
